import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPreview = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 11,
	viewBox: "0 0 17 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.49994 1.57158C4.73018 1.57158 2.45973 3.99944 1.54498 5.24165C1.42836 5.39958 1.42836 5.60073 1.54498 5.75865C2.45973 7.00087 4.73018 9.42873 8.49994 9.42873C12.2697 9.42873 14.5409 7.00087 15.4549 5.75865C15.5715 5.60073 15.5715 5.39958 15.4549 5.24165C14.5409 3.99944 12.2697 1.57158 8.49994 1.57158ZM0.402888 4.26486C1.44591 2.849 4.09101 0 8.5 0C12.909 0 15.5548 2.849 16.5971 4.26486C17.1343 4.99479 17.1343 6.00521 16.5971 6.73514C15.5548 8.151 12.909 11 8.5 11C4.09101 11 1.44591 8.151 0.402888 6.73514C-0.134296 6.00521 -0.134296 4.99479 0.402888 4.26486ZM8.50024 3.92896C7.69556 3.92896 7.04248 4.63296 7.04248 5.50038C7.04248 6.36781 7.69556 7.07181 8.50024 7.07181C9.30492 7.07181 9.95799 6.36781 9.95799 5.50038C9.95799 4.63296 9.30492 3.92896 8.50024 3.92896ZM5.58447 5.50023C5.58447 3.76459 6.88989 2.35737 8.49999 2.35737C10.1101 2.35737 11.4155 3.76459 11.4155 5.50023C11.4155 7.23587 10.1101 8.64309 8.49999 8.64309C6.88989 8.64309 5.58447 7.23587 5.58447 5.50023Z",
		fill: "white"
	})
});
export default SvgPreview;
